<template>
    <div class="check-avails-cal-container">
        <check-avails-cal
            :additional-months="12"
            :calendar.sync="calendar"
            @dateHovered="handleDateHover"
            @dateUnhovered="handleDateUnhover"
            @dateClicked="handleDatepick"
        >
            <template #month-label="{ month }">
                {{ month.label }}
            </template>
            <template #paginate-actions="{ handleNextMonths, handlePrevMonths }">
                <div class="paginate-actions">
                    <div @click="handlePrevMonths" class="prev-months"></div>
                    <div @click="handleNextMonths" class="next-months"></div>
                </div>
            </template>
        </check-avails-cal>
        <div class="block-message" v-if="maxCountStatus">
            This will create
            {{ selectedIndividualDates.length + actualEvents }} open events out of 5
            allowed.<br />
            Please remove days or upgrade your subscription.
        </div>
    </div>
</template>
<script>
    import ThreeMonthsViewCalendar from '@/components/ui/calendars/ThreeMonthsView.vue'
    import { MONTHS } from '@/constants/calendar'

    export default {
        name: 'CheckAvailsCalendar',

        emits: ['update-selected-dates', 'selected-count', 'update:disableCreateEventBtn'],

        components: {
            'check-avails-cal': ThreeMonthsViewCalendar
        },

        props: {
            selectedDates: {
                required: false,
                type: Array,
                default: () => []
            },
            events: {
                required: true,
                type: Array
            },
            subPlan: {
                required: true,
                type: String
            },
            actualEvents: {
                type: Number
            },
            disableCreateEventBtn: {
                type: Boolean
            }
        },

        data: () => ({
            calendar: [],
            currentDateRange: [],
            selectedIndividualDates: [],
            firstSelectedDate: null
        }),

        watch: {
            selectedDates: {
                handler: function (dates) {
                    if (!dates.length) return
                },
                immediate: true
            },
            calendar: function () {
                if (this.events.length) this.initializeEvents()
                if (this.selectedDates.length) {
                    this.selectedDates.forEach((date) => {
                        const dateArr = date.split(' ')
                        const month = dateArr[0]
                        const day = dateArr[1]
                        const year = dateArr[2]

                        const label = `${month} ${year}`

                        const dateObj = new Date(date)
                        const dayObj = this.getTargetDate(label, parseInt(day))

                        this.selectDate(dateObj, dayObj)
                    })
                }
            },
            selectedIndividualDates: {
                handler: function (dates) {
                    dates.length
                        ? this.$emit('update:disableCreateEventBtn', false)
                        : this.$emit('update:disableCreateEventBtn', true)
                },
                immediate: true
            }
        },

        methods: {
            initializeEvents() {
                this.markEventDays()
            },
            markEventDays() {
                for (let i = 0; i < this.events.length; i++) {
                    let event = this.events[i]
                    let date = new Date(event.startDate)

                    if (isNaN(date)) continue

                    let day = this.convertDateToDayObj(date)

                    this.$set(day, 'unavailable', true)
                }
            },
            handleDatepick(label, day) {
                let date = this.convertLabelToDate(label, day)

                this.selectDate(date, day)
            },
            handleDateHover(label, day) {
                if (day.unavailable) return
                if (!day.select) {
                    this.$set(day, 'hover', true)
                } else {
                    this.$set(day, 'unselect', true)
                }
            },
            handleDateUnhover(label, day) {
                if (day.unavailable) return
                this.$set(day, 'hover', false)
                this.$set(day, 'unselect', false)
            },

            eventsDate() {
                this.$emit('update-selected-dates', this.resolveIndividualSelected())
            },
            selectDate(date, day) {
                if (!day.select && !day.past) {
                    this.selectedIndividualDates.push(date)
                    this.$set(day, 'select', true)
                    this.$emit('selected-count', this.selectedIndividualDates.length)
                } else {
                    this.selectedIndividualDates = this.selectedIndividualDates.filter(
                        (d) => d.valueOf() !== date.valueOf()
                    )
                    this.$set(day, 'select', false)
                    this.$emit('selected-count', this.selectedIndividualDates.length)
                }
            },

            getTargetDate(label, day) {
                return this.calendar
                    .find((month) => month.label === label)
                    .days.find((d) => d.day === day)
            },

            appendDateSuffix(i) {
                i = parseInt(i)

                let j = i % 10,
                    k = i % 100

                if (j == 1 && k != 11) {
                    return i + 'st'
                }
                if (j == 2 && k != 12) {
                    return i + 'nd'
                }
                if (j == 3 && k != 13) {
                    return i + 'rd'
                }
                return i + 'th'
            },

            convertDateToLabel(date) {
                let year = date.getFullYear()
                let month = date.getMonth()

                return `${MONTHS[month]} ${year}`
            },

            convertDateToDayObj(date) {
                let label = this.convertDateToLabel(date)
                let day = date.getDate()

                return this.calendar
                    .find((month) => month.label === label)
                    .days.find((d) => d.day === day)
            },

            convertLabelToDate(label, day) {
                let year = label.split(' ')[1]
                let month = Object.keys(MONTHS).find(
                    (key) => MONTHS[key] === label.split(' ')[0]
                )

                return new Date(year, month, day.day)
            },

            convertDateRangeToDates() {
                let dates = []
                let dateRange = this.currentDateRange

                for (let i = 1; i < dateRange.length; i++) {
                    dates.push(new Date(dateRange[i].y, dateRange[i].m, dateRange[i].d))
                }

                dates.unshift(this.firstSelectedDate)
                dates.push(this.secondSelectedDate)

                return dates
            },

            resolveIndividualSelected() {
                let selected = ''

                for (let i = 0; i < this.selectedIndividualDates.length; i++) {
                    let label = this.convertDateToLabel(this.selectedIndividualDates[i]).split(
                        ' '
                    )
                    let day = this.appendDateSuffix(this.selectedIndividualDates[i].getDate())
                    let month = label[0]
                    let year = label[1]

                    if (!selected) {
                        selected = `${month} ${day} ${year}`
                    } else {
                        selected = selected + `, ${month} ${day} ${year}`
                    }
                }

                return selected
            }
        },
        computed: {
            maxCountStatus() {
                switch (this.subPlan) {
                    case 'VenueFree':
                    case 'ArtistFree':
                        return this.actualEvents + this.selectedIndividualDates > 5
                    case 'VenuePro':
                        return this.actualEvents + this.selectedIndividualDates > 10
                    case 'VenueGrowth':
                        return this.actualEvents + this.selectedIndividualDates > 20
                    case 'VenuePremium':
                        return false
                    default:
                        return false
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .block-message {
        margin-top: 83px;
        color: #e23453;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .three-view-prev-hidden-months {
        .month {
            margin-left: -302px !important;
        }
    }
    .check-avails-cal-container {
        width: 1160px;
        p {
            margin-bottom: 0px;
        }

        .info {
            margin-top: 91px;
            margin-bottom: 60px;
            margin-left: 80px;
            display: flex;
            flex-direction: column;
            gap: 12px;

            .title {
                color: #dedede;
                font-family: Instrument Sans;
                font-size: 44px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -1.76px;
            }

            .settings {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .range-select-input,
                .individual-select-input {
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    label {
                        cursor: grab;
                        color: #8b8b8b;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 125%;
                    }

                    .custom-radio {
                        width: 18px;
                        height: 18px;
                        border-radius: 20px;
                        border: 1.5px solid #8b8b8b;
                    }
                }

                .range-select-input,
                .individual-select-input:hover {
                    cursor: grab;
                }

                .range-select-input.selected,
                .individual-select-input.selected {
                    label {
                        color: #cdeb09;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 125%;
                    }

                    .custom-radio {
                        width: 18px;
                        height: 18px;
                        border-radius: 20px;
                        border: 1.5px solid #cdeb09;
                        background: #cdeb09;
                    }
                }
            }
        }

        .paginate-actions {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: absolute;
            top: 453px;
            width: 97%;

            .next-months {
                cursor: pointer;
                width: 16.743px;
                height: 16.743px;
                background: url(/images/icons/next.svg) no-repeat;
                background-size: 16.743px 16.743px;
                margin-right: 25px;
                position: relative;
                bottom: 309px;
            }

            .prev-months {
                cursor: pointer;
                width: 16.743px;
                height: 16.743px;
                background: url(/images/icons/prev.svg) no-repeat;
                background-size: 16.743px 16.743px;
                margin-left: 25px;
                position: relative;
                bottom: 309px;
            }
        }

        .selected-dates {
            margin-left: 80px;
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;

            .target-dates {
                color: #cdeb09;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
        }

        .action-btns {
            margin-top: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .select-btn {
                max-width: 600px;
                width: 100%;
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                background: #cdeb09;
                color: black;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                border: none;
            }
            .cancel-btn {
                margin-top: 25px;
                margin-bottom: 30px;
                color: #8b8b8b;
                font-family: Studio Pro;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 120%;
                text-decoration: underline;
                border: none;
                background: none;
            }
        }
    }
</style>
